<template lang="pug">
.v-collection-md-card.collection-md-card(v-if="data")
	.collection-md-card__card(v-if="data?.image" )
		img.collection-md-card__image(
			:src="data.image?.src"
			:alt="data.image?.alt")
		.collection-md-card__gradient
		.collection-md-card__info
			h4.collection-md-card__title(v-if="data.title") {{ data.title }}
			.collection-md-card__note(v-if="data.note" ) {{ data.note }}
			a.collection-md-card__link.btn.btn--lg.btn-gap(v-if="data.link" :href="data.link?.href")
				| {{ data.link?.text }}
				.btn-arrow.btn__icon
					.btn-arrow__track
						.btn-arrow__track-item
							v-scope
								v-svg-icon.icon-arrow(icon="btn-arrow")
						.btn-arrow__track-item
							v-scope
								v-svg-icon.icon-arrow(icon="btn-arrow")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';

export default {

	mixins: [
		sourceMixin
	],

	data() {
		return {
			data: null
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
		}
	}
}

</script>